/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { InboxComponentOld } from '../inbox-old/inbox.component';
import { InboxComponent } from '../inbox/inbox.component';
import { EmailDetailComponentOLD } from '../email-detail/email-detail.component';

export const inboxRouterConfig = [
  {
    path: 'inbox',
    component: InboxComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Inbox', uiTitle: 'Inbox' }
  },
  {
    path: 'inbox-old',
    component: InboxComponentOld,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Inbox', uiTitle: 'Inbox' }
  },
  {
    path: 'inbox/:id',
    component: EmailDetailComponentOLD,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Email detail', uiTitle: 'Email detail' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/inbox.routes.ts